export default __webpack_public_path__ + "static/media/0037.9cfb7e8f.jpg";